import { renderMarkdown } from "../lib/format";

export function Markdown({ md, onDark = false }: { md: string; onDark?: boolean }) {
  const html = renderMarkdown(md);
  return (
    <div
      className={`prose-apple ${onDark ? "prose-apple-dark" : ""}`}
      dangerouslySetInnerHTML={{ __html: html }}
    />
  );
}
